import { PageContainer, PageContentView } from 'components/shared';
import React from 'react';
import { useWorkflowStep } from "bcms-react";
import AcceptedDisclosuresWidget from './components/AcceptedDisclosuresWidget';
import OnlineMobileBankingWidget from './components/OnlineMobileBankingWidget';
import { getDefault, getWorkflowSteps } from 'components/workflows/AcceptedDisclosuresWorkflow';
/**
 * @function AcceptedDisclosuresPage
 * @return {React.Component}
 * @exported true
 * @description The main component for AcceptedDisclosuresPage
 */
export default function AcceptedDisclosuresPage(props) {
  const workflowStep = useWorkflowStep(getDefault, getWorkflowSteps);
  const disclosures = workflowStep.read('disclosures');

  return (
    <PageContainer className="accepted-disclosures-page">
        <PageContentView>
          <div className="flex-container flex-vertical flex-width">
            <AcceptedDisclosuresWidget disclosures={ disclosures } />
            <OnlineMobileBankingWidget />
          </div>
        </PageContentView>
    </PageContainer>
  )
}
